import { render, staticRenderFns } from "./sosHome.vue?vue&type=template&id=82b00a40&"
import script from "./sosHome.vue?vue&type=script&lang=js&"
export * from "./sosHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports